// extracted by mini-css-extract-plugin
module.exports = {"button":"Buttons_button__2q8P5","google":"Buttons_google__32wdj","facebook":"Buttons_facebook__3wYRO","yandex":"Buttons_yandex__1OFE-","vkontakte":"Buttons_vkontakte__npFts"};